
import { Component, Prop, Vue } from 'vue-property-decorator'
import FormContainer from '../../commons/forms/FormContainer.vue'
import NavigationLinks from '@/components/navigation_link/NavigationLinks.vue'
import DocumentField from '../../commons/fields/DocumentField.vue'
import TextFieldEditor from '../../commons/fields/TextFieldEditor.vue'
import { IPSEditFundingScope, IPSWhatWeDoForm } from '@/types/processingSteps'
import { IPhoto } from '@/types/photos'
import { INavigationLink } from '@/types/foerderApp'

@Component({
  components: {
    FormContainer,
    TextFieldEditor,
    DocumentField,
    NavigationLinks
  }
})
export default class WhatWeDoStep extends Vue {
  @Prop({ required: true }) whatWeDoForm!: IPSWhatWeDoForm
  @Prop({ required: true }) whatWeDoFormErrors!: IPSWhatWeDoForm
  @Prop({ required: true }) photoUploadUrl!: string
  @Prop({ required: true }) existingPhotos!: IPhoto[]
  @Prop({ required: true }) documentUploadUrl!: string
  @Prop({ required: true }) exitstingDocuments!: IPhoto[]
  @Prop({ required: true }) fundingScope!: IPSEditFundingScope
  @Prop({ required: true }) orgaUserCanEdit!: boolean

  handlePhotoUpdated() {
    this.$emit('photo-updated')
  }

  updateLinks(updatedLinks: INavigationLink[]) {
    this.$emit('update-links', updatedLinks)
  }
}
